import { Link } from 'react-router-dom';
import { ArrowRight, History } from 'lucide-react';

import { AccountsOverview } from '../../widgets/accounts-overview';
import { AllAccountsStatsTable } from '../../widgets/all-accounts-stats-table';

/**
 * Вкладка «Сводка»: плитки и график по всем аккаунтам, ниже — таблица за период.
 * Прежде это были две страницы меню: /dashboard (плитки) и /accounts-stats (таблица).
 */
export function StatsSummaryPage(): JSX.Element {
  return (
    <div className="flex flex-col gap-6">
      <AccountsOverview />
      <AllAccountsStatsTable />

      <Link
        to="/stats/history"
        className="group flex items-center justify-between gap-3 rounded-lg border bg-card px-4 py-3 transition-colors hover:bg-accent"
      >
        <span className="flex min-w-0 items-center gap-3">
          <History className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className="min-w-0">
            <span className="block text-sm font-medium">История сборов</span>
            <span className="block text-sm text-muted-foreground">
              Ежедневные снимки метрик и демография подписчиков
            </span>
          </span>
        </span>
        <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5" />
      </Link>
    </div>
  );
}
